import { Link } from '@lego/klik-ui';
import type { DetailSectionProps } from '@/components/common/details/DetailsBox';
import { DetailsBox } from '@/components/common/details/DetailsBox';
import type { StoreService } from '@/hooks/store';

type Props = {
  service: StoreService;
};

export const StoreServiceDetails = ({ service }: Props) => {
  const storeDetailsSections = [
    {
      items: {
        Documentation: {
          body: (
            <Link
              href={`https://baseplate.legogroup.io/docs/default/component/emma-store/services/${service.name}/`}
              isExternal
              p={0}
            >
              Baseplate
            </Link>
          ),
        },
        Repository: {
          body: (
            <Link
              href={`https://github.com/LEGO/EMMA-Store/tree/main/services/${service.name}`}
              isExternal
              p={0}
            >
              GitHub
            </Link>
          ),
        },
        'Image Name': { body: service.imageName },
      },
    },
  ] as DetailSectionProps[];

  return <DetailsBox sections={storeDetailsSections} title={service.name} />;
};
